import Config from 'organization/Event/Services/Apps/Obie/Config'
import LinkPage from 'organization/Event/Services/Apps/Obie/LinkPage'
import {
  BaseIntegration,
  OBIE,
  useServices,
} from 'organization/Event/Services/ServicesProvider'
import React from 'react'

export type UserRegistrationMode = 'auto' | 'sign_up'

export type ObieIntegration = BaseIntegration & {
  service: typeof OBIE
  obie_hub_id: string | null
  obie_offer_id: string | null
  user_registration_mode: UserRegistrationMode
}

export default function Obie() {
  const {isLinked} = useServices()
  const showConfig = isLinked(OBIE)

  if (showConfig) {
    return <Config />
  }

  return <LinkPage />
}
